module.exports = __webpack_public_path__ + "static/media/wedding-catering.3d9380a0.jpg";